import { MapState } from '@modules/Map/domain/interface/interface';

type WithMapState = {
  MapSlice: MapState;
};

export const MapStateSelector = (state: WithMapState): MapState =>
  state.MapSlice;
